import { render, staticRenderFns } from "./HomeBottomSection.vue?vue&type=template&id=15093738&scoped=true"
import script from "./HomeBottomSection.vue?vue&type=script&lang=js"
export * from "./HomeBottomSection.vue?vue&type=script&lang=js"
import style0 from "./HomeBottomSection.vue?vue&type=style&index=0&id=15093738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15093738",
  null
  
)

export default component.exports